/* Muse & Fur — Pet Photo Upload Field behavior
   Place in: assets/maf-photo-upload.js
   Loaded with `defer` near the end of theme.liquid.

   Uses delegated listeners on document so this keeps working
   regardless of how/when the product form section re-renders
   (variant changes, section re-renders in the theme editor, etc.)
*/

(function () {
  var MAX_FILE_MB = 20;
  var VALID_TYPES = ['image/png', 'image/jpeg', 'image/heic', 'image/webp'];

  function findWrapper(el) {
    return el.closest('[data-maf="photo-upload-wrapper"]');
  }

  function showError(wrapper, message) {
    var errorEl = wrapper.querySelector('[data-maf="upload-error"]');
    var dropzone = wrapper.querySelector('[data-maf="dropzone"]');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
    if (dropzone) dropzone.classList.add('has-error');
  }

  function clearError(wrapper) {
    var errorEl = wrapper.querySelector('[data-maf="upload-error"]');
    var dropzone = wrapper.querySelector('[data-maf="dropzone"]');
    if (errorEl) errorEl.hidden = true;
    if (dropzone) dropzone.classList.remove('has-error');
  }

  function renderPreview(wrapper, file) {
    var placeholder = wrapper.querySelector('[data-maf="placeholder"]');
    var preview = wrapper.querySelector('[data-maf="preview"]');
    var previewImg = wrapper.querySelector('[data-maf="preview-image"]');

    var reader = new FileReader();
    reader.onload = function (e) {
      previewImg.src = e.target.result;
      preview.hidden = false;
      placeholder.hidden = true;
    };
    reader.readAsDataURL(file);
  }

  function resetField(wrapper) {
    var input = wrapper.querySelector('[data-maf="photo-input"]');
    var placeholder = wrapper.querySelector('[data-maf="placeholder"]');
    var preview = wrapper.querySelector('[data-maf="preview"]');
    var previewImg = wrapper.querySelector('[data-maf="preview-image"]');

    if (input) input.value = '';
    if (previewImg) previewImg.src = '';
    if (preview) preview.hidden = true;
    if (placeholder) placeholder.hidden = false;
  }

  function validateFile(file) {
    if (!file) return 'Please upload a photo of your pet before adding this portrait to your cart.';
    if (VALID_TYPES.indexOf(file.type) === -1) {
      return 'Please upload a JPG, PNG, HEIC, or WEBP photo.';
    }
    if (file.size > MAX_FILE_MB * 1024 * 1024) {
      return 'That photo is a little large — please upload one under ' + MAX_FILE_MB + 'MB.';
    }
    return null;
  }

  // File chosen via click or drag-drop
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-maf="photo-input"]');
    if (!input) return;

    var wrapper = findWrapper(input);
    var file = input.files && input.files[0];
    var error = validateFile(file);

    if (error) {
      showError(wrapper, error);
      resetField(wrapper);
      return;
    }

    clearError(wrapper);
    renderPreview(wrapper, file);
  });

  // Drag and drop
  document.addEventListener('dragover', function (e) {
    var dropzone = e.target.closest('[data-maf="dropzone"]');
    if (!dropzone) return;
    e.preventDefault();
    dropzone.classList.add('is-dragover');
  });

  document.addEventListener('dragleave', function (e) {
    var dropzone = e.target.closest('[data-maf="dropzone"]');
    if (!dropzone) return;
    dropzone.classList.remove('is-dragover');
  });

  document.addEventListener('drop', function (e) {
    var dropzone = e.target.closest('[data-maf="dropzone"]');
    if (!dropzone) return;
    e.preventDefault();
    dropzone.classList.remove('is-dragover');

    var wrapper = findWrapper(dropzone);
    var input = wrapper.querySelector('[data-maf="photo-input"]');
    var file = e.dataTransfer.files && e.dataTransfer.files[0];

    if (!file) return;
    var error = validateFile(file);
    if (error) {
      showError(wrapper, error);
      return;
    }

    // Assign the dropped file to the actual input so it submits with the form
    var dt = new DataTransfer();
    dt.items.add(file);
    input.files = dt.files;

    clearError(wrapper);
    renderPreview(wrapper, file);
  });

  // Remove photo
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-maf="remove-photo"]');
    if (!removeBtn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrapper = findWrapper(removeBtn);
    resetField(wrapper);
  });

  // Block add-to-cart submission (covers both native form submit
  // and most AJAX add-to-cart implementations, which still fire
  // a 'submit' event on the <form> before intercepting it).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var wrapper = form.querySelector && form.querySelector('[data-maf="photo-upload-wrapper"]');
    if (!wrapper) return; // not a form with our upload field

    var input = wrapper.querySelector('[data-maf="photo-input"]');
    var hasFile = input && input.files && input.files.length > 0;

    if (!hasFile) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError(wrapper, 'Please upload a photo of your pet before adding this portrait to your cart.');
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true); // capture phase, so this runs before theme's own AJAX handlers

  // Ensure the form can actually carry a file. Most Dawn-based themes
  // build FormData(form) for AJAX add-to-cart, which works regardless
  // of the enctype attribute — but we set it anyway for safety/fallback.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-maf="photo-upload-wrapper"]').forEach(function (wrapper) {
      var form = wrapper.closest('form');
      if (form) form.setAttribute('enctype', 'multipart/form-data');
    });
  });
})();
